// extracted by mini-css-extract-plugin
export default {"container":"Fp-z","brandName":"Gp-z","productName":"Hp-z","productNamePdpEnhancements":"Ip-z","breakLongProductName":"Jp-z"};